import { NgClass, NgFor, NgIf, NgStyle } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import { PostService } from '../services/post.service';
import { StripHtmlAndConvertPipe } from '../strip-html-and-convert.pipe';

interface WhatNew {
  title: string;
  titleKh: string;
  desc: string;
  descKh: string;
  date: string;
  img: string;
  class: string;
  url: string;
}

@Component({
  selector: 'app-all-posts',
  standalone: true,
  imports: [NgFor, RouterLink, NgClass, NgIf, TranslateModule, RouterLinkActive, StripHtmlAndConvertPipe, NgStyle],
  templateUrl: './all-posts.component.html',
  styleUrl: './all-posts.component.css'
})
export class AllPostsComponent {

  baseApiUrl = environment.baseApiUrl;
   
  activePaginateIcon = this.baseApiUrl + '/uploads/images/icons/active_paginate.svg';
  inactivePaginateIcon = this.baseApiUrl + '/uploads/images/icons/inactive_paginate.svg';
  activeNext = this.baseApiUrl + '/uploads/images/icons/next_active.png';
  inactiveNext = this.baseApiUrl + '/uploads/images/icons/next_inactive.png';
  inactivePrevious = this.baseApiUrl + '/uploads/images/icons/previous_inactive.png';
  activePrevious = this.baseApiUrl + '/uploads/images/icons/previous_active.png';
  
  page: number = 1;
  currentPage: number = 1;
  limit: number = 10;
  totalPages: number = 1;

  currentLanguage: string = '';

  allPosts: any[] = [];
  
  constructor(private router: Router, private route: ActivatedRoute, private translate: TranslateService, private postService: PostService) {}   
     
     
     ngOnInit(): void {
       this.route.paramMap.subscribe(params => {
         const pageParam = params.get('page');
     
         if (pageParam !== null) {
           this.page = +pageParam; // Convert to number if not null
         } else {
           this.page = 1; // Assign default value if param is null
         }
     
         this.currentPage = this.page;
       });
   
        this.currentLanguage = this.translate.currentLang || this.translate.defaultLang;
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
          this.currentLanguage = event.lang;
        })
        
       this.loadPosts(this.page, this.limit);
     }

       isKhmer(): boolean {
    return this.translate.currentLang === 'kh';
  }

  isEnglish(): boolean {
    return this.translate.currentLang === 'en';
  }

    loadPosts(page: number, limit: number): void {
      this.postService.getPosts(page, limit).subscribe({
        next: (response: any) => {
        // response.data.posts contains the posts array
        this.allPosts = response.data.posts;
        this.page = response.data.current_page;
        this.totalPages = response.data.total_pages;
      },
      error: (err) => {
        console.error('Failed to load posts', err);
      }
    });
  }
   
  previousPage(): void {
  if (this.page > 1) {
    this.page--;
    this.loadPosts(this.page, this.limit);
  }
}

nextPage(): void {
  if (this.page < this.totalPages) {
    this.page++;
    this.loadPosts(this.page, this.limit);
  }
}

isPreviousDisabled(): boolean {
  return this.page === 1;
}

isNextDisabled(): boolean {
  return this.page === this.totalPages;
}

}
